var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { M as MapSpriteSchema } from "../../MapSprite-b447e6f3.js";
import * as PIXI from "pixi.js";
import ImageLoader from "../../loader/ImageLoader.js";
import { T as TransformSchema } from "../../Transform-9450b7b5.js";
import { registerPixiComponent } from "../ComponentRegistry.js";
import { MapEntityTypeSchema } from "../entity/Types.js";
import "../../decorators/type.js";
import "ajv";
import "../../utils/clone.js";
import "bitecs";
import "../../utils/typehelpers.js";
import "../../enums-86f58524.js";
import "../../global-33d5eebf.js";
import "../types.js";
import "../../utils/byteArray.js";
class MapSpriteComponentPixi {
  constructor() {
    __publicField(this, "ids", /* @__PURE__ */ new Set());
    __publicField(this, "schema", MapSpriteSchema);
    __publicField(this, "entities", {});
  }
  init(entity, gameModel, viewport) {
    const spriteData = gameModel.getTypedUnsafe(entity, MapSpriteSchema);
    const mapEntityType = gameModel.getTypedUnsafe(entity, MapEntityTypeSchema);
    const sprite = new PIXI.Sprite(ImageLoader.getInstance().getPixiTexture(spriteData.name));
    const transformSchema = gameModel.getTypedUnsafe(entity, TransformSchema);
    const position = transformSchema.position;
    sprite.anchor.set(0.5, 0.5);
    sprite.x = position.x;
    sprite.y = position.y;
    sprite.width = mapEntityType.width;
    sprite.height = mapEntityType.height;
    sprite.zIndex = 100;
    this.entities[entity] = sprite;
    this.ids.add(entity);
    viewport.addChild(sprite);
  }
  run(entity, gameModel, viewport) {
    const sprite = this.entities[entity];
    const spriteData = gameModel.getTypedUnsafe(entity, MapSpriteSchema);
    if (spriteData.opacity) {
      sprite.alpha = spriteData.opacity;
      sprite.visible = true;
    } else {
      sprite.visible = false;
    }
  }
  cleanup(entity, gameModel, viewport) {
    const sprite = this.entities[entity];
    viewport.removeChild(sprite);
    this.ids.delete(entity);
    delete this.entities[entity];
  }
}
registerPixiComponent("MapSprite", MapSpriteComponentPixi);
export {
  MapSpriteComponentPixi
};
//# sourceMappingURL=MapSprite.js.map
